import { useEffect, useState } from "react";

import { SVGSprite } from "@/components/Atoms";

import FilterInput from "./FilterInput";

import { classNameGenerator, addKey } from "@/utils";

import { useAppDispatch, useAppSelector } from "@/hooks";

import * as actions from "@/redux/RecipeReducer";

import styles from "./RecipeFilters.module.scss";

interface RecipeFiltersProps {}

const RecipeFilters: React.FC<RecipeFiltersProps> = () => {
  const dispatch = useAppDispatch();
  const cls = classNameGenerator(styles);

  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedAttribute, setSelectedAttribute] = useState([]);
  const [appliedCategory, setAppliedCategory] = useState([]);
  const [appliedAttribute, setAppliedAttribute] = useState([]);

  const { data, categories, attributes } = useAppSelector(
    (state) => state.recipe
  );

  const recipeList = data?.recipeList;

  useEffect(() => {
    if (!appliedCategory?.length && !appliedAttribute?.length && recipeList) {
      dispatch(dispatch(actions.resetRecipeThread()));
    }
  }, [dispatch, appliedCategory, appliedAttribute, recipeList]);

  useEffect(() => {
    if (appliedCategory?.length || appliedAttribute?.length) {
      dispatch(
        actions.getRecipeThread({
          ...addKey("attributeIDs", appliedAttribute?.join(",")),
          ...addKey("categoryIDs", appliedCategory?.join(",")),
        })
      );
    }
  }, [dispatch, appliedCategory, appliedAttribute]);

  const isAppliedFilters =
    appliedCategory?.length > 0 || appliedAttribute.length > 0;

  return (
    <div className={cls("recipeFilters")}>
      <div className={cls("container")}>
        <div className={cls("filters")}>
          {/* <FilterInput
            placeholder="Filter by Categories"
            name="categories"
            options={categories}
            className={cls("categories")}
            value={selectedCategory}
            onChange={setSelectedCategory}
            onSubmit={setAppliedCategory}
            selectedItemText={`${selectedCategory?.length} ${
              selectedCategory?.length > 1 ? "Categories" : "Category"
            } selected`}
          /> */}
          <FilterInput
            placeholder="Filter by Attribute"
            name="attributes"
            options={attributes}
            className={cls("attributes")}
            value={selectedAttribute}
            onChange={setSelectedAttribute}
            onSubmit={setAppliedAttribute}
            selectedItemText={`${selectedAttribute?.length} Attribute${
              selectedAttribute?.length > 1 ? "s" : ""
            } selected`}
          />
        </div>
        {isAppliedFilters && (
          <div className={cls("appliedFilters")}>
            {categories
              ?.filter?.((c) => appliedCategory.includes(c.value))
              ?.map(({ label, value }, index) => (
                <div key={index} className={cls("filterChip")}>
                  {label}
                  <SVGSprite
                    icon="icon-header-close"
                    className={cls("closeIcon")}
                    onClick={() => {
                      const _appliedCategory = appliedCategory?.filter(
                        (id) => value !== id
                      );
                      setSelectedCategory(_appliedCategory);
                      setAppliedCategory(_appliedCategory);
                    }}
                  />
                </div>
              ))}
            {attributes
              ?.filter?.((a) => appliedAttribute.includes(a.value))
              ?.map(({ label, value }, index) => (
                <div key={index} className={cls("filterChip")}>
                  {label}
                  <SVGSprite
                    icon="icon-header-close"
                    className={cls("closeIcon")}
                    onClick={() => {
                      const _selectedAttribute = selectedAttribute?.filter(
                        (id) => value !== id
                      );
                      setSelectedAttribute(_selectedAttribute);
                      setAppliedAttribute(_selectedAttribute);
                    }}
                  />
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipeFilters;
